import React, { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import SideMenu from '../components/SideMenu';
import Dashboard from '../pages/Dashboard';
import Chat from '../pages/Chat';
import ChatHistory from '../pages/ChatHistory';
import Message from '../pages/Message';
import Group from '../pages/Group';
import ChatGroup from '../pages/ChatGroup';
import UserConfig from '../pages/UserConfig';
import Company from '../pages/Company';
import Department from '../pages/Department';
import ChatUser from '../pages/ChatUser';
import Parameter from '../pages/Parameter';
import ChatSupervisor from '../pages/ChatSupervisor';
import ChatActive from '../pages/ChatActive';
import Settings from '../pages/Settings';
import Feedback from '../pages/Feedback';

const logOut = (): void => {
  localStorage.removeItem('@LiveChat:token');
  localStorage.removeItem('@LiveChat:user');
  localStorage.removeItem('@LiveChat:connectionId');

  window.location.reload();
};

const RootAuthenticated: React.FC = () => {
  const [inactive, setInactive] = useState(false);

  const collapse = (inactiveValue: boolean): void => {
    setInactive(inactiveValue);
  };

  return (
    <>
      <SideMenu onCollapse={collapse} />
      <div
        className={`container-Menu bg-dark.bg-gradient ${
          inactive ? 'inactive' : ''
        }`}
        style={{
          height: 'calc(100vh - 9rem)',
          marginTop: '4.6rem',
        }}
      >
        <Routes>
          <Route path="/" element={<ChatActive />} />
          <Route path="/chathistory" element={<ChatHistory />} />
          <Route path="/message" element={<Message />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/Usuario" element={<ChatGroup />} />
          <Route path="/Configuracoes" element={<Settings />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/conversa" element={<ChatGroup />} />
          <Route path="/empresa" element={<Company />} />
          <Route path="/departamento" element={<Department />} />
          <Route path="/chatUser" element={<ChatUser />} />
          <Route path="/chatSupervisor" element={<ChatSupervisor />} />
          <Route path="/chatActive" element={<ChatActive />} />
          <Route path="/Feedback" element={<Feedback />} />

          <Route path="*" element={<ChatActive />} />
        </Routes>
      </div>
    </>
  );
};

export default RootAuthenticated;
